export default {
  'zh-CN': {
    noDataText: '无数据',
    loadingText: '加载中'
  },
  'en': {
    noDataText: 'No data',
    loadingText: 'Loading'
  },
  'ja': {
    noDataText: '无数据_ja',
    loadingText: '加载中_ja'
  }
}
